module.exports = __webpack_public_path__ + "img/mode4.cb2a0b78.png";